import {SellpiaDom as _} from "./SellpiaDom";

export class StockViewBase {
    constructor(options) {
        if (new.target === StockViewBase) {
            throw new TypeError("Cannot construct Abstract instances directly");
        }
        this.options = options;
    }

    show() {
        this.shadow.show();
    }

    hide() {
        this.shadow.hide();
    }

    /**
     * 레이어를 오픈 합니다.
     */
    openLayout({options, last_update, makeshop_product}) {
        if (!this.status) {
            this.status = "LOADING";
            this.createLayout({options, last_update, makeshop_product});
        }
        this.show();
    }

    closeLayout() {
        this.hide();
    }

    /**
     * 재고 현황을 생성함
     * @param {*} option
     */
    getStatusDom(option) {
        return _.div("txt-c").adds([
            _.span(option.status, option.status_class),
            option.stock_in_due_date ? new _("br") : false,
            option.stock_in_due_date ? _.span("(입고예정일 : "+option.stock_in_due_date+")").style("font-size:0.9em") : false
        ])
    }

    createHeader(header, update_date) {
        return _.div('l-tit').adds([
            (new _('strong')).text('실시간 재고현황 보기'),
            update_date ? (new _('span')).text("업데이트 날자 : " + update_date ) : null
        ]);
    }

    createfoot() {
        return (new _('ul', 'l-txt')).adds([
            (new _('li')).html("<strong>- 오늘 출발 가능</strong> : 지금 주문시, 오늘 중으로 출고하여, 내일 받아 볼 수 있습니다!"),
            (new _('li')).html("<strong>- 주문 가능</strong> : 주문은 가능하며 2~5일정도 준비기간이 소요되는 상품입니다."),
            (new _('li')).html("<strong>- 일시 품절</strong> : 일시적으로 상품이 품절된 상태로, 7일이내에 재입고되는 상품입니다."),
            (new _('li')).html("<strong>- 매장 재고 확인</strong> : 오프라인 매장에서 바로 구매할 수 있는 상품이 있는 재고를 확인할 수 있습니다!")
        ]);
    }

    static getMainAddress(address) {
        return address?.replace(/\[\S*\]/, "").trim().split(" ")[0];
    }

    show_location(option) {
        let pos = option.pos;
        if (!this.location) {
            this.location = {
                dom: _.div('l-stock-comm').attrs({id:"layer-stock-addr"}),
                list : new _("ul")
            }

            let close_button = _.a('l-close layer-close', "#layer-stock-addr");
            close_button.click(() => { this.location.dom.hide();});

            this.location.dom.add(_.div("layer").add(_.div('layer-pop').adds([
                close_button,
                _.div('l-tit').add(_.strong("지역선택")),
                _.div('l-cont').add(this.location.list)
            ])));
            this.main.add(this.location.dom);
        }

        let pos_keys = Object.keys(pos);
        let addrs = [];
        pos_keys.map(key=>{
            let addr = StockView.getMainAddress(pos[key].shop_address);
            if (addr) {
                if (!addrs.find((_addr) => _addr === addr)) {
                    addrs.push(addr);
                }
            }
        })

        this.location.list.html("");
        this.location.list.add((new _("li")).add((new _("label")).adds([
            (new _('input')).attrs({type:'checkbox', name:'pos_location_list', value:"ALL"})
                .addClass("input-chk").event("change",(event)=>{
                this.location.list.dom.querySelectorAll("input").forEach((dom)=>{
                    if (dom.value === "ALL") { return; }
                    dom.checked = event.target.checked;
                })
            }),
            _.strong(" 전체")
        ])))
        this.location.list.adds(
            addrs.map(addr=>{
                return (new _("li")).add((new _("label")).adds([
                    (new _('input')).attrs({type:'checkbox', name:'pos_location_list', value:addr})
                        .addClass("input-chk").event("change", (event)=>{
                        if (!event.target.checked) {
                            this.location.list.dom.querySelector("input[value=ALL]").checked = false;
                        }
                    }),
                    _.span(" "+addr)
                ]));
            })
        );
        this.location.list.add(_.div('btn-confirm').add(_.a("layer-close", "#layer-stock-addr").text("확인").click((event)=>{
            // 지역 선택 후 확인 버튼 클릭
            let selected_addrs = [];
            this.location.list.dom.querySelectorAll("input").forEach((dom)=>{
                if (dom.value === "ALL") { return; }
                if (dom.checked) {
                    selected_addrs.push(dom.value);
                }
            })
            this.pos.selected_addrs = selected_addrs;
            this.location.dom.hide();
            this.show_pos(option); // 포스 화면을 갱신 해줍니다.
        })))

        this.location.list.dom.querySelectorAll("input").forEach((dom)=>{
            // 기존에 선택되어 있던 주소를 세팅
            if (dom.value === "ALL") { return; }
            dom.checked = this.pos.selected_addrs.find(addr=>addr===dom.value) ? true : false;
        })

        this.location.dom.show();
    }

    show_pos(option) {
        if (!this.pos) {
            this.pos = {
                dom: _.div('l-stock-comm').attrs({id: "layer-stock-map"}),
                option: (new _("strong")),
                selected_addrs : localStorage.getItem("__MakeshopStockLocationAddrString")?.split(",") ?? [],
                shop: _.div('l-cont')
            }
            let close_button = _.a('l-close layer-close', "#layer-stock-map");
            close_button.click(() => { this.pos.dom.hide(); });

            // producttitl
            let product_title = window.product_name || option.product_title || "";

            this.pos.dom.add(_.div("layer").add(_.div('layer-pop').adds([
                close_button,
                _.div('l-tit').html("<strong>오프라인 매장 재고</strong><span>재고유무를 꼭 전화로 확인하고 방문해주세요!</span>"),
                _.div("l-prd clearfix").adds([
                    // TODO img
                    _.div("prd-name").text(product_title), // TODO 상품명
                    this.pos.option
                ]),
                _.div("l-addr").adds([
                    _.strong("회원 배송지 기준 "),
                    _.a("btn-sel-addr layer-open", "#layer-stock-addr").text("지역선택").click(() => {
                        this.show_location(option);
                    })
                ]),
                this.pos.shop
            ])));
            this.main.add(this.pos.dom);
        }

        this.pos.option.text(option.option_title);
        this.pos.shop.html("");
        this.pos.shop.add(_.table().attrs({border: 0, summary: ""}).adds([
            new _("caption"),
            (new _("colgroup")).adds([
                (new _("col")).attrs({width: "*"}),
                (new _("col")).attrs({width: "80"}),
                (new _("col")).attrs({width: "110"}),
            ]),
            (new _("thead")).html('<tr>\n' +
                '<th scope="col"><div class="txt-c">오프라인 매장</div></th>\n' +
                '<th scope="col"><div class="txt-c">주문유무</div></th>\n' +
                //'<th scope="col"><div class="txt-c">구매</div></th>\n' + // 아직 사용하지 않음
                '</tr>'),
            (new _("tbody")).adds(Object.keys(option.pos).filter(key=>{
                if (this.pos.selected_addrs.length > 0) {
                    return this.pos.selected_addrs.find(addr=>{
                        return StockView.getMainAddress(option.pos[key].shop_address) === addr
                    }) ? true : false;
                }
                return true; // 미선택시 전체
            }).map(key => {
                return _.tr().adds([
                    _.td().add(_.div('txt-l').add((new _("dl")).adds([
                        (new _('dt')).text(option.pos[key].shop_name||""),
                        (new _('dd', "addr")).text(option.pos[key].shop_address ?? ""),
                        (new _('dd')).text("전화번호 " + (option.pos[key].shop_phone ?? "")),
                        (new _('dd')).text("운영시간 " + (option.pos[key].service_time  ?? "")),
                    ]))),
                    _.td().add(_.div('txt-c').add(_.span( option.pos[key].stock_avail, option.pos[key].stock_avail_class))),
                    // _.td().add(_.div('txt-c').adds([ // 아직 사용하지 않음
                    //     _.a("s-order-buy on delivery", "#none").text("매장 택배발송"),
                    //     _.a("s-order-buy on shop", "#none").html("구매후<br>매장수령"),
                    // ]))
                ]);
            }))
        ]))

        this.pos.dom.show();
    }

    getOptionHeader(option_category) {
        if (!option_category) { // 옵션 정보가 없는 경우
            return [{title: "옵션"}];
        }
        return option_category.filter(category=>category.is_mandatory).map(category => {
            return {title: category.title};
        }) || [{title: "옵션"}];
    }

    createLayout({options, last_update, makeshop_product}) {throw new Error('Must be implement.');}
    createBody(options, headers) { throw new Error('Must be implement.');}
    createBodyPos(options, headers) { throw new Error('Must be implement.');}
    writeStyle() { throw new Error('Must be implement.');}
}
